module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5nnKC"))).then(() => module.bundle.root('jnagv'));